import React from 'react'

import { IconLoader2 } from '@tabler/icons-react'

import './SpinningLoader.scss'

export const SpinningLoader = (props) => {
  return <IconLoader2 className="spinning" {...props} />
}
